/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { KundeDto as OkEgisServiceModelsDtoKundeDto } from '../models/OK/Egis/Service/Models/DTO/kunde-dto';
import { PartnerExternalInfoDto as OkEgisServiceModelsDtoPartnerExternalInfoDto } from '../models/OK/Egis/Service/Models/DTO/partner-external-info-dto';
import { PartnerKundeDto as OkEgisServiceModelsDtoPartnerKundeDto } from '../models/OK/Egis/Service/Models/DTO/partner-kunde-dto';
import { ServiceItemDto as OkEgisServiceModelsDtoServiceItemDto } from '../models/OK/Egis/Service/Models/DTO/service-item-dto';
import { PartnerGatewayEnum as OkEgisServiceModelsEntitiesEnumsPartnerGatewayEnum } from '../models/OK/Egis/Service/Models/Entities/Enums/partner-gateway-enum';

@Injectable({
  providedIn: 'root',
})
export class KundeService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getKunde
   */
  static readonly GetKundePath = '/api/v1/Kunde';

  /**
   * Get Kunde information.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getKunde()` instead.
   *
   * This method doesn't expect any request body.
   */
  getKunde$Response(params: {
    okKundeAftaleNr?: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<OkEgisServiceModelsDtoKundeDto>> {

    const rb = new RequestBuilder(this.rootUrl, KundeService.GetKundePath, 'get');
    if (params) {
      rb.query('okKundeAftaleNr', params.okKundeAftaleNr, {});
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsDtoKundeDto>;
      })
    );
  }

  /**
   * Get Kunde information.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getKunde$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getKunde(params: {
    okKundeAftaleNr?: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<OkEgisServiceModelsDtoKundeDto> {

    return this.getKunde$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsDtoKundeDto>) => r.body as OkEgisServiceModelsDtoKundeDto)
    );
  }

  /**
   * Path part for operation getPartnerKundeDtoListByPartnerNo
   */
  static readonly GetPartnerKundeDtoListByPartnerNoPath = '/api/v1/Kunde/GetByGateway';

  /**
   * Get Kunde information.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPartnerKundeDtoListByPartnerNo()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPartnerKundeDtoListByPartnerNo$Response(params: {

    /**
     * PartnerNo
     */
    partnerNo?: number;

    /**
     * skip number of customers
     */
    skip?: number;

    /**
     * number to take
     */
    take?: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<Array<OkEgisServiceModelsDtoPartnerKundeDto>>> {

    const rb = new RequestBuilder(this.rootUrl, KundeService.GetPartnerKundeDtoListByPartnerNoPath, 'get');
    if (params) {
      rb.query('partnerNo', params.partnerNo, {});
      rb.query('skip', params.skip, {});
      rb.query('take', params.take, {});
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<OkEgisServiceModelsDtoPartnerKundeDto>>;
      })
    );
  }

  /**
   * Get Kunde information.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getPartnerKundeDtoListByPartnerNo$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPartnerKundeDtoListByPartnerNo(params: {

    /**
     * PartnerNo
     */
    partnerNo?: number;

    /**
     * skip number of customers
     */
    skip?: number;

    /**
     * number to take
     */
    take?: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<Array<OkEgisServiceModelsDtoPartnerKundeDto>> {

    return this.getPartnerKundeDtoListByPartnerNo$Response(params).pipe(
      map((r: StrictHttpResponse<Array<OkEgisServiceModelsDtoPartnerKundeDto>>) => r.body as Array<OkEgisServiceModelsDtoPartnerKundeDto>)
    );
  }

  /**
   * Path part for operation getByServiceaftaleNo
   */
  static readonly GetByServiceaftaleNoPath = '/api/v1/Kunde/GetByServiceaftaleNo/{serviceaftaleNo}';

  /**
   * Get Anlaeg information.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getByServiceaftaleNo()` instead.
   *
   * This method doesn't expect any request body.
   */
  getByServiceaftaleNo$Response(params: {

    /**
     * serviceaftaleNo
     */
    serviceaftaleNo: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<OkEgisServiceModelsDtoServiceItemDto>> {

    const rb = new RequestBuilder(this.rootUrl, KundeService.GetByServiceaftaleNoPath, 'get');
    if (params) {
      rb.path('serviceaftaleNo', params.serviceaftaleNo, {});
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsDtoServiceItemDto>;
      })
    );
  }

  /**
   * Get Anlaeg information.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getByServiceaftaleNo$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getByServiceaftaleNo(params: {

    /**
     * serviceaftaleNo
     */
    serviceaftaleNo: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<OkEgisServiceModelsDtoServiceItemDto> {

    return this.getByServiceaftaleNo$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsDtoServiceItemDto>) => r.body as OkEgisServiceModelsDtoServiceItemDto)
    );
  }

  /**
   * Path part for operation getByPartnerGateway
   */
  static readonly GetByPartnerGatewayPath = '/api/v1/Kunde/GetByPartnerGateway/{partnerGateway}';

  /**
   * Get Anlaeg information for partner GW.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getByPartnerGateway()` instead.
   *
   * This method doesn't expect any request body.
   */
  getByPartnerGateway$Response(params: {

    /**
     * partnerGateway
     */
    partnerGateway: OkEgisServiceModelsEntitiesEnumsPartnerGatewayEnum;

    /**
     * skip number of customers
     */
    skip?: number;

    /**
     * number to take
     */
    take?: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<Array<OkEgisServiceModelsDtoServiceItemDto>>> {

    const rb = new RequestBuilder(this.rootUrl, KundeService.GetByPartnerGatewayPath, 'get');
    if (params) {
      rb.path('partnerGateway', params.partnerGateway, {});
      rb.query('skip', params.skip, {});
      rb.query('take', params.take, {});
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<OkEgisServiceModelsDtoServiceItemDto>>;
      })
    );
  }

  /**
   * Get Anlaeg information for partner GW.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getByPartnerGateway$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getByPartnerGateway(params: {

    /**
     * partnerGateway
     */
    partnerGateway: OkEgisServiceModelsEntitiesEnumsPartnerGatewayEnum;

    /**
     * skip number of customers
     */
    skip?: number;

    /**
     * number to take
     */
    take?: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<Array<OkEgisServiceModelsDtoServiceItemDto>> {

    return this.getByPartnerGateway$Response(params).pipe(
      map((r: StrictHttpResponse<Array<OkEgisServiceModelsDtoServiceItemDto>>) => r.body as Array<OkEgisServiceModelsDtoServiceItemDto>)
    );
  }

  /**
   * Path part for operation getPartnerInformation
   */
  static readonly GetPartnerInformationPath = '/api/v1/Kunde/GetPartnerInformation';

  /**
   * Get service partner information.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPartnerInformation()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPartnerInformation$Response(params: {
    okKundeAftalenr?: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<OkEgisServiceModelsDtoPartnerExternalInfoDto>> {

    const rb = new RequestBuilder(this.rootUrl, KundeService.GetPartnerInformationPath, 'get');
    if (params) {
      rb.query('okKundeAftalenr', params.okKundeAftalenr, {});
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsDtoPartnerExternalInfoDto>;
      })
    );
  }

  /**
   * Get service partner information.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getPartnerInformation$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPartnerInformation(params: {
    okKundeAftalenr?: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<OkEgisServiceModelsDtoPartnerExternalInfoDto> {

    return this.getPartnerInformation$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsDtoPartnerExternalInfoDto>) => r.body as OkEgisServiceModelsDtoPartnerExternalInfoDto)
    );
  }

}
